var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortAmountAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sort Ascending") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 24v-24h-4v24h-5l7 7 7-7h-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18h18v4h-18v-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12h14v4h-14v-4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6h10v4h-10v-4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 0h6v4h-6v-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAmountAsc);
export default __webpack_public_path__ + "static/media/sort-amount-asc.b2ae2ef3.svg";
export { ForwardRef as ReactComponent };